<template>
  <div id="btnGroup">
    <b-button v-if="!btnSelected"
              @click="selected"
              size="sm"
              variant="outline-dark">
      Другое</b-button>
    <b-button v-if="btnSelected" size="sm" variant="primary">
      <b-icon icon="check-circle"></b-icon>
      Другое</b-button>
  </div>
</template>

<script>
export default {
  name: 'FormButtonBlock',
  props: {
    isChoice: {
      type: Boolean,
      default: false
    },
    value: {
      default: -2,
      type: Number
    }
  },
  data () {
    return {
      btnSelected: false
    }
  },
  methods: {
    selected () {
      if (!this.btnSelected) {
        this.btnSelected = true
        this.$emit('action-selected')
      }
    }
  },
  beforeMount () {
    console.log('val', this.value)
    this.btnSelected = this.value === -1
  },
  watch: {
    value (val) {
      console.log('val', val)
      this.btnSelected = val === -1
    }
  }
}
</script>

<style scoped>
  #btnGroup {
    margin-top: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/FormButtonBlock.vue